var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75019 3.75V14.8624L9.70475 12.3104C9.89863 12.2273 10.1185 12.2297 10.3105 12.317L20.2502 16.835V3.75H3.75019ZM21.7502 17.9836V3.6C21.7502 2.85444 21.1458 2.25 20.4002 2.25H3.60019C2.85461 2.25 2.25019 2.85442 2.25019 3.6V15.9832C2.24994 15.9944 2.24994 16.0057 2.25019 16.017V20.4C2.25019 21.1456 2.85463 21.75 3.60019 21.75H20.4002C21.1458 21.75 21.7502 21.1456 21.7502 20.4V18.0168C21.7504 18.0057 21.7504 17.9947 21.7502 17.9836ZM20.2502 18.4827L9.99128 13.8195L3.75019 16.4943V20.25H20.2502V18.4827ZM16.0003 6.75C15.3099 6.75 14.7503 7.30964 14.7503 8C14.7503 8.69036 15.3099 9.25 16.0003 9.25C16.6906 9.25 17.2503 8.69036 17.2503 8C17.2503 7.30964 16.6906 6.75 16.0003 6.75ZM13.2503 8C13.2503 6.48122 14.4814 5.25 16.0003 5.25C17.5191 5.25 18.7503 6.48122 18.7503 8C18.7503 9.51878 17.5191 10.75 16.0003 10.75C14.4814 10.75 13.2503 9.51878 13.2503 8Z",
    fill: "#7B7D7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.6d69c3b46b82ab3f1989e7cc4febdb25.svg";
export { ForwardRef as ReactComponent };